import { makeAutoObservable, observable, toJS  } from "mobx";
import { quaiboDailyProductionService } from "../services/quaibodailyproductionservice";
import { saveAs } from "file-saver";
import moment from "moment";
import { getCurrentUser } from "../../../Utility/modules/helpers";
const _ = require("underscore");
class QuaiboDailyProductionStore {
  constructor() {
    makeAutoObservable(this);
  }

  showQuaiboDailyProductionDialog = false;
  dailyProductions = observable.map({});
  wellparameters = observable.map({});
  IsEquityProduction = 0;
  selTab = "1";
  showSQeryDialog = false;
  isDownloadingTemplate = false;
  isExporting = false;
  isSaving = false;
  isLoading = false;
  isLoadingDailyProd = false;
  isLoaded = false;
  wellParametersLoaded = false;
  sheetName = "Main";
  showUploadErrorMessage = false;
  productionview = "gross";
  showRemarkPane = false;
  remarkObj = { title: "", remark: "<div></div>" };
  resultFromQuery = false;
  view = "upload";
  showWellAllocationExportDialog = false;
  exportOnlyWellAllocationVolume = false;
  uploadDate = moment(new Date()).format("DD-MMM-YYYY");
  gridHeaderText = `QUAIBO JV(Gross) PRODUCTIONS from ${moment(new Date())
    .startOf("month")
    .format("ddd DD-MMM-YYYY")} to ${moment(new Date())
    .endOf("month")
    .format("ddd DD-MMM-YYYY")}`;
  initFormaData = {
    blpd: 0,
    bsw: 0,
    condensate: 0,
    crudeInjectionGGF: 0,
    cumCondProduction: 0,
    cumGasProduction: 0,
    cumGrossProduction: 0,
    cumNetProduction: 0,
    cumWaterProduction: 0,
    drainedWater: 0,
    flareGas: 0,
    fuelGas: 0,
    gas: 0,
    oil: 0,
    gor: 0,
    operatingHrs: 0,
    ownUseGas: 0,
    productionDate: moment(new Date())._d,
    quaiboDailyProductionId: 0,
    remarks: "",
    stationAPI: 0,
    uploadedBy: null,
    uploadedOn: null,
    water: 0,
    evacuationUptime: 0,
    evacuatedGas: 0,
    evacuatedCondensate: 0,
  };
  uploadErrors = [];
  selRow = {};
  queryCriteria = {
    startDate: moment(new Date())
      .startOf("month")
      .format("YYYY-MM-DDT00:00:00.000Z"),
    endDate: moment(new Date())
      .endOf("month")
      .format("YYYY-MM-DDT00:00:00.000Z"),
    fromInception: false,
    specificDate: false,
  };
  disableCommand = true;
  showQuaiboRythmDrawer = false;
  async DownlaodDailyProductionTemplate() {
    try {
      this.isDownloadingTemplate = true;
      const res = await quaiboDailyProductionService.downloadTemplate();
      saveAs(res, "QuaiboProductionTemplate.xlsx");
    } catch (error) {
      throw error;
    } finally {
      this.isDownloadingTemplate = false;
    }
  }
  async loadInitialWellParameters() {
    const retval =
      await quaiboDailyProductionService.getInitialWellParameters();
    console.log("para", retval);

    if (retval.length) {
      this.wellparameters.clear();

      retval.forEach((para) => {
        this.wellparameters.set(para.quaiboDailyProductionWellId, para);
      });
      this.wellParametersLoaded = true;
    }
  }
  async loadProductions() {
    try {
      this.isLoading = true;
      let res = [];
      res = await quaiboDailyProductionService.loadProductionHistory(
        this.queryCriteria,
        this.productionview
      );
      console.log(res);
      this.dailyProductions.clear();
      res.prodHistory.forEach((prod) => {
        this.dailyProductions.set(prod.quaiboDailyProductionId, {
          ...prod,
          productionDate: moment(prod.productionDate).format("L"),
          strippedRemarks: prod.remarks
            ? prod.remarks.replace(/(<([^>]+)>)/gi, " ")
            : null,

          pdYear: moment(prod.productionDate).format("YYYY"),
          pdYearMonth: moment(prod.productionDate).format("YYYY-MMM"),
        });
      });

      this.isLoaded = true;

      return res;
    } catch (error) {
      throw error;
    } finally {
      this.isLoading = false;
    }
  }
  async saveDailyProduction(data) {
    try {
      this.isSaving = true;
      const uploadedBy = getCurrentUser()?.fullName;
      const res = await quaiboDailyProductionService.saveDailyProduction(
        {
          ...data,
          productionDate:
            data.productionDate.toString().charAt(0) === "-"
              ? data.productionDate.toString().substr(1)
              : data.productionDate,
        },
        [...this.wellparameters.values()],
        uploadedBy
      );
      console.log(res);
      return res;
    } catch (error) {
      throw error;
    } finally {
      this.isSaving = false;
    }
  }
  get isValidProductionData() {
    const { oil, gas, condensate } = toJS(this.initFormaData);
    return oil + gas + condensate >= 0;
  }

  async deleteProduction(id, prodDate) {
    try {
      const retVal = await quaiboDailyProductionService.deleteProduction(
        id,
        prodDate
      );
      return retVal;
    } catch (error) {
      throw error;
    }
  }
  clearFormValues() {
    let init = {
      blpd: 0,
      bsw: 0,
      condensate: 0,
      crudeInjectionGGF: 0,
      cumCondProduction: 0,
      cumGasProduction: 0,
      cumGrossProduction: 0,
      cumNetProduction: 0,
      cumWaterProduction: 0,
      drainedWater: 0,
      flareGas: 0,
      fuelGas: 0,
      gas: 0,
      gor: 0,
      oil: 0,
      operatingHrs: 0,
      ownUseGas: 0,
      productionDate: moment(new Date())._d,
      quaiboDailyProductionId: 0,
      remarks: "",
      stationAPI: 0,
      uploadedBy: null,
      uploadedOn: null,
      water: 0,
      evacuationUptime: 0,
      evacuatedGas: 0,
      evacuatedCondensate: 0,
    };
    this.initFormaData = init;
    this.uploadDate = moment(new Date())._d;
  }

  get totalBLPD() {
    const vals = _.map([...this.wellparameters.values()], (x) => toJS(x));
    let sum = vals.reduce(
      (s, f) => Number(s) + Number(f.blpd),
      0
    ); /* .toFixed(5); */
    this.initFormaData.blpd = sum;
    return sum;
  }

  async getWellContributions(pdate) {
    try {
      const retVal = await quaiboDailyProductionService.getWellContributions(
        pdate
      );
      return retVal;
    } catch (error) {
      throw error;
    }
  }

  async getQuaiboDailProductionById(productionId) {
    try {
      this.isLoadingDailyProd = true;
      const retVal = await quaiboDailyProductionService.getQuaiboProductionById(
        productionId,
        this.IsEquityProduction
      );
      console.log(retVal);
      this.initFormaData = retVal;
    } catch (error) {
      throw error;
    } finally {
      this.isLoadingDailyProd = false;
    }
  }
  async exportWellAllocation(exportDate) {
    try {
      this.isExporting = true;
      const [startDate, endDate] = exportDate;
      const res = await quaiboDailyProductionService.exportWellAllocation(
        moment(startDate).format("MM/DD/YYYY"),
        moment(endDate).format("MM/DD/YYYY"),
        this.exportOnlyWellAllocationVolume
      );

      saveAs(res, "quaibo_well_allocation_export.xlsx",{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
    } catch (error) {
      throw error;
    } finally {
      this.isExporting = false;
    }
  }
}



const quaiboDailyProductionStore = new QuaiboDailyProductionStore();
export default quaiboDailyProductionStore;

